
<ng-template [ngIf]="isLoadingStoricoNazionale">
      <app-loading></app-loading>
</ng-template>
<div fxFlex="95%" class="mt-2">
  <p-table #listiniDT styleClass="p-datatable-striped" [value]="storicoNazionale" dataKey="id" 
  [loading]="isLoadingStoricoNazionale"
  [sortField]="'id'" [sortOrder]="1">

  <ng-template pTemplate="header" >
      <tr class="custom-header-bg">
        <th class="text-center" style="font-size: 14px;">
          MODIFICATO
        </th>
          <th class="text-center" style="font-size: 14px;">
              SCL.1
          </th>
          <th class="text-center" style="font-size: 14px;">
              SCL.2
          </th>
          <th class="text-center" style="font-size: 14px;">
              SCL.3
          </th>
          <th class="text-center" style="font-size: 14px;">
              SCL.4
          </th>
          <th class="text-center" style="font-size: 14px;">
              SCL.5
          </th>
          <th class="text-center" style="font-size: 14px;">
            PREVENTIVO BASE
          </th>
         
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-row>
    <tr [ngClass]="{'active-nazionale': !row.eliminato}">
            
      <td class="text-center"> 
        <i *ngIf="!row.eliminato"   class="pi pi-verified" style="color:white;  margin-left: 5px;"  tooltipPosition="top"  pTooltip="Listino corrente"></i>
        <span *ngIf="row.eliminato" class="text-uppercase font-bold" style="font-weight: 500; ">{{utilService.formattaDataDaDate(row.eliminato)}}</span> 
      </td>
      <td class="text-center"> 
        <span *ngIf="row.eliminato" class="text-uppercase" style="font-weight: 500; ">{{row.scl1}} €</span> 
        <span *ngIf="!row.eliminato" class="text-uppercase" style="font-weight: 500; color:white">{{row.scl1}} €</span> 
      </td>
      <td class="text-center"> 
        <span *ngIf="row.eliminato" class="text-uppercase" style="font-weight: 500; ">{{row.scl2}} €</span> 
        <span *ngIf="!row.eliminato" class="text-uppercase" style="font-weight: 500; color:white">{{row.scl2}} €</span> 
      </td>
      <td class="text-center"> 
        <span *ngIf="row.eliminato" class="text-uppercase" style="font-weight: 500; ">{{row.scl3}} €</span> 
        <span *ngIf="!row.eliminato" class="text-uppercase" style="font-weight: 500; color:white">{{row.scl3}} €</span> 
      </td>
      <td class="text-center"> 
        <span *ngIf="row.eliminato" class="text-uppercase" style="font-weight: 500; ">{{row.scl4}} €</span> 
        <span *ngIf="!row.eliminato" class="text-uppercase" style="font-weight: 500; color:white">{{row.scl4}} €</span> 
      </td>
      <td class="text-center"> 
        <span *ngIf="row.eliminato" class="text-uppercase" style="font-weight: 500; ">{{row.scl5}} €</span> 
        <span *ngIf="!row.eliminato" class="text-uppercase" style="font-weight: 500; color:white">{{row.scl5}} €</span> 
      </td>
      <td class="text-center"> 
        <span *ngIf="row.eliminato" class="text-uppercase font-semibold" style="font-weight: 500; ">{{row.preventivoBase}} €</span> 
        <span *ngIf="!row.eliminato" class="text-uppercase font-semibold" style="font-weight: 500; color:white">{{row.preventivoBase}} €</span> 
      </td>
     
    </tr>
  </ng-template>
  
  </p-table>

    <div class="border-top-1 surface-border mt-5" style="text-align: center;">
      <button pButton pRipple icon="pi pi-times" (click)="dialogRef.close(true)" label="CHIUDI" class="p-button-outlined w-6 mt-3"></button>
    </div>
    
    <div>
    